import { render, staticRenderFns } from "./diagnostics.vue?vue&type=template&id=675c1460&scoped=true&"
import script from "./diagnostics.vue?vue&type=script&lang=js&"
export * from "./diagnostics.vue?vue&type=script&lang=js&"
import style0 from "./diagnostics.vue?vue&type=style&index=0&id=675c1460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c1460",
  null
  
)

export default component.exports